import React, { useState, useEffect, useRef } from 'react';
import GetRequest from '../../service/GetRequest';
import { Button } from 'primereact/button';
import { ListBox } from 'primereact/listbox';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { SelectButton } from 'primereact/selectbutton';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Skeleton } from 'primereact/skeleton';
import 'primeicons/primeicons.css';
import './style.css';
import 'primeflex/primeflex.css';
import AddProductForm from './Forms/AddProductForm';
import GridViewProductItemCard from './Cards/GridViewProductItemCard';
import ListViewProductItemCard from './Cards/ListViewProductItemCard';

export const ProductViewContainer = () => {
  const [branchList, setBranchList] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const [productsLoading, setProductsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState({});
  const [layout, setLayout] = useState('grid');
  const [loading, setLoading] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);

  const [productCreationPopupVisible, setProductCreationPopupVisible] = useState(false);


  const justifyOptions = [
    {icon: 'pi pi-th-large', value: 'grid'},
    {icon: 'pi pi-bars', value: 'list'},
];

  const toast = useRef(null);

  const fetchStoreDetails = () => {
    GetRequest("v1/store-management-service/view/my/store", true)
      .then(response => {
        if (!response || !response.storeBranches || response.storeBranches.length === 0) {
          console.error("Empty response or undefined data for store branches");
        } else {
          setBranchList(response.storeBranches);
          setSelectedBranch(response.storeBranches[0]); // Select the first branch by default
          setSelectedBranchId(response.storeBranches[0].id); //// Select the first branch ID by default
        }
      })
      .catch(error => {
        console.error("Error fetching store details:", error);
      });
  };

    const fetchCategories = async (branchId) => {
      try {
          const response = await GetRequest(`v1/inventory-service/view/branches/${branchId}/categories`);
          let categoriesList = [{ name: "All", value: 0 }];

          if (response && response.length > 0) {
              const formattedCategories = response.map(category => ({
                  name: category.name,
                  value: category.categoryId
              }));
              categoriesList = [...categoriesList, ...formattedCategories];
          } else {
              console.log("Empty response or undefined data for categories");
          }
          setCategoriesList(categoriesList);
          setSelectedCategoryId(0); // Set default category ID to 0
          getProductsData(0, branchId); // Fetch all products for the selected branch
      } catch (error) {
          console.error("Error fetching categories:", error);
      }
    };

    const getProductsData = async (categoryId, branchId) => {
        try {
            setProductsLoading(true);
            let response;

            if (categoryId === 0) {
                response = await GetRequest(`v1/inventory-service/view/branches/${branchId}/items?isActive=false`);
            } else {
                response = await GetRequest(`v1/inventory-service/view/products/${categoryId}?branchId=${branchId}&isActiveProductsOnly=false`);
            }

            if (!response || response.length === 0) {
                console.log("Empty response or undefined data for categories");
                setProducts([]);
                setProductsLoading(false);
            } else {
                setProducts(response); // Return the response array
                setProductsLoading(false);
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
        } finally {
          setProductsLoading(false);
      }
    };

    const handleBranchChange = (e) => {
      const selectedBranch = branchList.find(branch => branch.id === e.target.value);
      setSelectedBranch(selectedBranch);
      setSelectedBranchId(e.target.value);
      fetchCategories(e.target.value);
      console.log("selected branch city:",selectedBranch.city);
      console.log("Selected branch:", e.value);
  };
  
  
    const onCategoryChange = (e) => {
        const selectedCategoryId = e;
        setSelectedCategoryId(selectedCategoryId);
        console.log("The category changed to:", selectedCategoryId);
        getProductsData(selectedCategoryId, selectedBranchId); // Fetch products for the selected category and branch
    };

  const confirm1 = () => {
    setProductCreationPopupVisible(true);
    load();
  };

  const load = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    fetchStoreDetails();
  }, []);

  useEffect(() => {
    if (selectedBranch.id) {
      fetchCategories(selectedBranch.id);
    }
  }, [selectedBranch]);

  useEffect(() => {
    if (selectedBranchId && selectedCategoryId) {
      getProductsData(selectedCategoryId, selectedBranchId);
    } 
  }, [selectedBranchId, selectedCategoryId]);

  const itemTemplate = (products) => {
    if (layout === 'list') {
      return (
        <div className="list-container w-[100%]">
          {productsLoading ? (
                <div className="mt-2">
                    {Array.from({ length: 6 }).map((_, index) => (
                            <Skeleton key={index} width="100%" height="210px" className="col-12 mb-3"></Skeleton>
                        ))}
                </div>
            ) : products.length === 0 ? (
                <div className="text-center p-4 mt-40">No products found</div>
            ) : (
                <ScrollPanel style={{ width: '100%', height: '550px' }} className="custombar2">
                    {products.map(product => <ListViewProductItemCard key={product.itemId} {...product} />)}
                </ScrollPanel>
            )}
        </div>
      );
    } else if (layout === 'grid') {
      return (
        <ScrollPanel style={{ width: '100%', height: '560px' }} className="custombar2">
          <div className="w-[100%]">
          {productsLoading ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-[100%] ml-1 mt-1">
                        {Array.from({ length: 6 }).map((_, index) => (
                            <Skeleton key={index} width="16rem" height="300px"></Skeleton>
                        ))}
                    </div>
                ) : products.length === 0 ? (
                    <div className="text-center p-4 flex items-center justify-center h-full">No products found</div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-[100%] ml-1 mt-1">
                        {products.map(product => (
                            <GridViewProductItemCard {...product} key={product.itemId} />
                        ))}
                    </div>
                )}
          </div>
        </ScrollPanel>
      );
    }
  };
  
  const onChangeLayout = (e) => {
    setLayout(e.value); // Update the layout state based on user selection
  };
  
  const justifyTemplate = (option) => {
    return <i className={option.icon}></i>;
}

const onProductPopupClose = (e) => {
  setProductCreationPopupVisible(false);
  };

  const addProduct = (e) => {
    setProductCreationPopupVisible(false);
    toast.current.show({ severity: 'info', summary: 'Added', detail: 'product added successfully!', life: 3000 });
    };
  
  return (
    <div className="card product-container">
    <div className='max-w-[15%] w-[15%] h-[695px] hidden sm:block lg:block'>
    <div className='text-[14px] mt-10'>Browse by category</div>
      <div className="flex justify-center mx-auto mt-10">
      <ScrollPanel style={{ width: '100%', height: '560px' }} className="custombar2">

        <ListBox
          value={selectedCategoryId}
          onChange={(e) => onCategoryChange(e.value)}
          options={categoriesList}
          optionLabel="name"
          className="w-full md:w-14rem"
        />
        </ScrollPanel>
      </div>
    </div>

    <div className="product-card max-w-[85%] w-[85%]">
      <div className="flex justify-content-end items-center gap-3 product-card-header">

      <div className="block lg:hidden">
      <Dropdown
          value={selectedCategoryId}
          options={categoriesList.map(category => ({ label: category.name, value: category.value }))}
          onChange={(e) => onCategoryChange(e.value)}
          optionLabel="label"
          placeholder="Select a Branch"
          className="max-w-[30px] max-h-[30px] overflow-hidden input"
        />
    </div>
        <Dropdown
          value={selectedBranchId}
          options={branchList.map(branch => ({ label: branch.name, value: branch.id }))}
          onChange={handleBranchChange}
          optionLabel="label"
          placeholder="Select a Branch"
          className="w-full md:w-14rem"
        />
        <Button label="Add new product" outlined icon="pi pi-plus" severity="success" loading={loading} onClick={confirm1} />
        <SelectButton layout={layout} onChange={(e) => onChangeLayout(e)} itemTemplate={justifyTemplate} optionLabel="value" options={justifyOptions} />
      </div>
      <div className="" style={{ width: '100%', height: '560px' }}>
        {itemTemplate(products)}
      </div>

      <Dialog header="Add new Product" visible={productCreationPopupVisible} style={{ width: '50vw' }} onHide={() => {if (!productCreationPopupVisible) return; setProductCreationPopupVisible(false); }}>
          <div className="flex flex-column align-items-center p-5 surface-overlay border-round">
                            <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem">
                                <i className="pi pi-objects-column text-5xl"></i>
                            </div>
                            <span className="font-bold text-2xl block mb-2 mt-4">
                                Branch
                            </span>
                            <p className="mb-0">
                                <span className="flex align-items-center gap-2">
                                      <i className="pi pi-map-marker"></i>
                                      <span className="font-semibold">{selectedBranch.name}</span>
                                  </span>
                            </p>
                            <Divider />

                           
                            <br/>
                            <AddProductForm branchId={selectedBranch.id} onSubmit={addProduct} onCancel={onProductPopupClose}/>
                        </div>
      </Dialog>
      
    </div>

    <Toast ref={toast} />
  </div>
  );
};
